<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: wjx
 * @Date: 2019-03-15 10:35:09
 * @LastEditTime: 2019-05-29 12:53:25
 -->
<template>
  <el-dialog :visible="true" title="关联详情" lock-scroll @close='closeEvent' width='800' top='100'
    style="margin-top:5vh;height:800px;">
    <el-table v-loading="loading" :data="tableData" border style="width: 100%" :stripe="true"
      :highlight-current-row="false">
      <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="enterpriseName" label="专区名称">
      </el-table-column> -->
      <el-table-column :show-overflow-tooltip="true" align="center" prop="projectName" label="项目名称">
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center" label="关联时间">
          <template slot-scope="scope">
            {{scope.row.createDt|transAllTime}}
          </template>
        </el-table-column>
    </el-table>
    <!--分页-->
    <div style="display:flex;justify-content:center;align-items:center;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="paginationData.pageNum" :total="totalElements" :page-size="paginationData.pageSize"
      layout="total, prev, pager, next, jumper" style="padding:15px">
    </el-pagination>
    <el-button type='primary' style="height:40px;" @click="closeEvent">确定</el-button>
    </div>
    
  </el-dialog>
</template>
<script>
  import {
    pageInation
  } from "@/Mixin/listMixin";
  import {
    initSearch
  } from "@/Mixin/initSearch";
  import {
    project,channel
  } from "@/api/ajax";
  export default {
    components: {

    },
    mixins: [pageInation, initSearch],
    props: {
      searchQuery:{}
    },
    data() {
      return {
        getList: channel.projectList, // 获取列表的AJAX
      }
    },
    computed: {},
    watch: {},
    created() {

    },
    methods: {
      closeEvent() {
        this.$parent.showDetail = false
      },
      confirm(item) {
        this.$confirm('是否确认取票', '请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getTicket({
            id: item.id
          }).then(res => {
            if (res.status == 1) {
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success'
              });
              item.isWatch = 1
            }
          }).catch(err => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          })
        })

      },


    }
  }

</script>
<style lang="scss" scoped>
  .confirnBtn {
    position: absolute;
    width: 100px;
    height: 50px;
    top: 50%;
    right: 1%;
    margin-left: -50px;
    margin-top: -25px;
    text-align: center;
    font-size: 16px;
  }

  .childRuleForm {
    width: 90%;
    margin-left: 4%;
    // border: 1px solid rgb(128,128,128);

  }

</style>
